export default {
  configPage: {
    notFound: 'ID do produto não encontrado',
    tabs: {
      overview: 'Geral',
      users: 'Usuários',
      apiTokens: 'Tokens de API',
      security: 'Segurança'
    },
    dangerZone: {
      title: 'Zona de Perigo',
      description: 'Ações irreversíveis para este produto.',
      deleteTitle: 'Excluir produto',
      deleteDescription: 'Esta ação é permanente e não pode ser desfeita. Todos os dados do produto serão removidos.',
      deleteButton: 'Excluir',
      confirmTitle: 'Confirmar exclusão do produto',
      confirmDescription: 'Esta ação é irreversível. Digite o nome do produto para confirmar.',
      confirmLabel: 'Digite o nome do produto para confirmar:',
      confirmHint: 'Digite "{{name}}" para confirmar'
    }
  },
  overview: {
    title: 'Geral',
    description: 'Gerencie as informações e configurações do seu produto',
    saving: 'Salvando...',
    save: 'Salvar'
  },
  users: {
    title: 'Usuários do Produto',
    description: 'Gerencie quais usuários têm acesso a este produto'
  },
  apiTokens: {
    title: 'Tokens de API',
    description: 'Gerencie tokens de API para acesso de terceiros',
    create: 'Criar',
    createTitle: 'Criar Token de API',
    createDesc: 'Crie um novo token vinculado a este produto.',
    createSuccessDesc: 'Seu token de API foi criado com sucesso. Você pode copiá-lo agora ou acessá-lo mais tarde na lista de tokens.',
    tokenName: 'Nome do token',
    tokenNamePlaceholder: 'ex: Integração de Produção',
    setExpiration: 'Definir expiração',
    expiresAt: 'Expira em',
    yourToken: 'Seu Token de API',
    copyToken: 'Copiar token',
    copyWarning: '⚠️ Importante: Copie este token agora! Após fechar este diálogo, apenas o prefixo do token será mostrado por segurança. O token completo não pode ser recuperado depois.',
    noTokens: 'Nenhum token de API',
    noTokensDesc: 'Crie um token de API para permitir que integrações de terceiros acessem endpoints específicos.',
    createFirst: 'Criar seu primeiro token',
    availableApis: 'APIs Disponíveis',
    apisDescription: 'Endpoints acessíveis com tokens de API deste produto',
    swaggerLink: 'Para detalhes completos dos endpoints, consulte a documentação Swagger',
    copy: 'Copiar',
    copyPrefixBtn: 'Copiar Prefixo',
    copyFullToken: 'Copiar token completo',
    copyPrefix: 'Copiar prefixo do token (regenere para obter o token completo)',
    regenerate: 'Regenerar',
    regenerateTitle: 'Regenerar token - cria um novo token e mostra para você',
    active: 'Ativo',
    inactive: 'Inativo',
    created: 'Criado',
    expires: 'Expira',
    usageCount: 'Contagem de uso',
    tokenCopied: 'Token copiado para a área de transferência',
    prefixCopied: 'Prefixo do token copiado para a área de transferência'
  },
  dialog: {
    usersLoading: "Os usuários do produto ainda estão carregando. Tente novamente em instantes."
  }
};
